import MicroModal from 'micromodal';

export default {

	init() {
		console.log('modals init...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
		window.addEventListener("load", this.bindLoadEvents);
	},

	bindEvents() {
		$('template[data-js=modal]').each(function (index, elem) {
			var modal = elem.content.firstElementChild.cloneNode(true);
			document.body.appendChild(modal);
			elem.remove();
		});

		Modal.bindModalEvents();
	},

	bindModalEvents() {
		if (!$('[data-micromodal-trigger]').length) {
			return;
		}

		$('[data-micromodal-trigger]').on('click', function (e) {
			e.preventDefault();
		});

		MicroModal.init({
			onShow: Modal.show,
			onClose: Modal.close,
			disableFocus: true,
			disableScroll: true
		});
	},

	bindLoadEvents() {
		const hash = window.location.hash;
		const modalId = hash.substring(1);
		let target = document.getElementById(modalId);

		if(!target || !target.classList.contains('sh-modal')) {
			return;
		}

		setTimeout(function() {
			MicroModal.show(modalId, {
				onShow: Modal.show,
				onClose: Modal.close,
				disableFocus: true,
				disableScroll: true
			});
		}, 500);
	},

	show(modal, trigger, event) {
		$('html').addClass('has-modal-open').addClass('is-modal-open');
		Modal.updateUrl('#'+modal.getAttribute('id'));
	},

	close(modal, trigger, event) {
		$('html').removeClass('has-modal-open').removeClass('is-modal-open');
		Modal.updateUrl(window.location.href.split('#')[0]);
	},

	updateUrl(url) {
		if(window.history.pushState) {
			window.history.pushState({}, '', url);
		}
	},

};
